import styled from 'styled-components'
import { mediaBreakpointDown } from 'styles/minxins'

export const StyledHeader = styled.div`
  height: 60px;
  &.stickyHeader {
    position: sticky;
    z-index: 100;
    top: 0;
    background-color: #fff;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  }
`
export const StyledBody = styled.div`
  padding: 16px 20px;
  animation: fadeIn linear 0.2s;
  will-change: opacity;
  ${mediaBreakpointDown({
    breakpoint: 'lg',
    content: `
    padding: 16px 8px;
    `
  })}
  ${mediaBreakpointDown({
    breakpoint: 'md',
    content: `
    padding: 16px 0px;
    `
  })}
`

export const StyledContent = styled.div`
  overflow-x: hidden;
  min-height: 100vh;
`
